import { IStore } from '..';
import { createSelector } from 'reselect';

const getLoggedInUser = (state: IStore) => state.user.loggedInUser;
const getOrders = (state: IStore) => state.user.orders;
const getLoginView = (state: IStore) => state.user.loginView;
const getMenuView = (state: IStore) => state.user.menuView;
const getIsLoginUser = (state: IStore) => state.user.isLoginUser;
const getLoginInput = (state: IStore) => state.user.loginInput;
const getIsLoggedIn = (state: IStore) => state.user.loggedInUser != null;
const getIsFetchingOrders = (state: IStore) => state.user.isFetchingOrders;
const getIsFetchingUser = (state: IStore) => state.user.isFetchingUser;
const getCountryList = (state: IStore) => state.user.countryList;
const getMenuError = (state: IStore) => state.user.menuError;
const getLoginError = (state: IStore) => state.user.loginError;
const getNewsletterSuccess = (state: IStore) => state.user.newsletterSuccess;
const getNewsletterEmail = (state: IStore) => state.user.newsletterEmail;
const getLocale = (state: IStore) => state.user.locale;

const getSortedOrderHistory = createSelector(
  [getOrders],
  (orderHistory) => {
    return orderHistory ? orderHistory.sort((a, b) => (a.orderID > b.orderID ? -1 : 1)): [];
  },
);

const getUserEmail = createSelector(
  [getLoggedInUser, getIsLoggedIn],
  (userInfo, isLoggedIn) => {
    return isLoggedIn && userInfo && userInfo.email ? userInfo.email : '';
  },
);

const getUserName = createSelector(
  [getLoggedInUser, getIsLoggedIn],
  (userInfo, isLoggedIn) => {
    return isLoggedIn && userInfo && userInfo.firstName ? userInfo.firstName : null;
  },
);

const getLoginEmailInput = createSelector(
  [getLoginInput],
  (input) => {
    return input && input.email ? input.email : '';
  },
);

export { 
  getIsLoggedIn,
  getLoginView,
  getMenuView,
  getLocale,
  getIsLoginUser,
  getLoggedInUser,
  getUserEmail,
  getUserName,
  getLoginInput,
  getSortedOrderHistory,
  getIsFetchingOrders,
  getIsFetchingUser,
  getCountryList,  
  getMenuError,
  getLoginError,
  getNewsletterSuccess,
  getNewsletterEmail,
};


// WEBPACK FOOTER //
// ./src/store/User/selectors.tsx